import script from "./ProximasPeleas.vue?vue&type=script&setup=true&lang=js"
export * from "./ProximasPeleas.vue?vue&type=script&setup=true&lang=js"

import "./ProximasPeleas.vue?vue&type=style&index=0&id=daf0a984&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-daf0a984"]])

export default __exports__